import { Mail, Users, Bike, ShoppingBasket } from "lucide-react";

const StatCard = ({ icon: Icon, label, value, testid }) => (
  <div data-testid={testid} className="rounded-3xl border border-forest/10 bg-white p-6">
    <span className="flex h-10 w-10 items-center justify-center rounded-2xl bg-fresh/15">
      <Icon className="h-5 w-5 text-fresh" />
    </span>
    <p className="mt-4 font-syne text-3xl font-extrabold text-forest">{value}</p>
    <p className="mt-1 text-xs font-bold uppercase tracking-[0.15em] text-forest/50">{label}</p>
  </div>
);

export const AdminStats = ({ leads, apps }) => {
  const drivers = apps.filter((a) => a.role === "driver").length;
  return (
    <div className="grid grid-cols-2 gap-4 lg:grid-cols-4">
      <StatCard icon={Mail} label="App waitlist leads" value={leads.length} testid="stat-leads" />
      <StatCard icon={Users} label="Applications" value={apps.length} testid="stat-applications" />
      <StatCard icon={Bike} label="Drivers" value={drivers} testid="stat-drivers" />
      <StatCard icon={ShoppingBasket} label="Pickers" value={apps.length - drivers} testid="stat-pickers" />
    </div>
  );
};
